angular.module('filters').filter('fullDatetime', function() {
  return function(input) {
    if (input) {
      return moment(input).format('ddd, Do MMM, YYYY h:mma');
    }
  };
});
